import React, { ChangeEvent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoImg from '@/assets/images/logo.png';
import { ConfigType } from '@/types/configType';

interface SelectBoxProps {
  data: ConfigType[];
  name: string;
  defaultUrl: string;
}

function SelectBox({ data, name, defaultUrl }: SelectBoxProps) {
  const navigate = useNavigate();

  const handleOnChanged = useCallback(
    ({ target }: ChangeEvent<HTMLSelectElement>) => {
      const { value } = target;
      window.scrollTo(0, 0);
      navigate(`?activeName=${value}`);
    },
    [navigate],
  );

  return (
    <>
      <div className={'outlinks'}>
        <a className={'outlinks__logo'} href="https://www.nhn-commerce.com/" target={'_blank'}>
          <img src={LogoImg} alt="NHN commerce 홈으로 가기" />
        </a>
        <div className={'outlinks__api'}>
          <a className={`api-link`} href="#" style={{ display: 'none' }}>
            고도몰 shop API <span className="ico ico--arrow"></span>
          </a>
          <a className={`api-link`} href={defaultUrl}>
            고도몰 server API <span className="ico ico--arrow"></span>
          </a>
          <a
            className={`api-link api-link--out-link`}
            href="https://www.nhn-commerce.com/support/board?secondaryCategoryNo=63&primaryCategoryNo=62&page=1&searchValue="
            target="_blank"
          >
            {`API `}
            <span className="api-link__kor">업데이트</span>
            <span className="ico ico--badge"></span>
            <span className="ico ico--out-link"></span>
          </a>
          <a className={`api-link`} href="https://workspace.nhn-commerce.com/" target="_blank">
            <span className="api-link__kor" style={{ marginInlineStart: '0' }}>
              워크스페이스 바로가기
            </span>
            <span className="ico ico--out-link"></span>
          </a>
        </div>
        <select onChange={handleOnChanged} value={name}>
          {data.map(({ name }) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}

export default React.memo(SelectBox);
